(() => {
  (() => {
    class t extends HTMLElement {
      currentVariant;
      form;
      swatch;
      input;
      prices;
      priceDiscount;
      specialDiscount;
      option0;
      option1;
      option2;
      option3;
      imageBar;
      stars;
      button;
      SignButton;
      save_additional;
      affirmText;
      gallery;
      gallery2;
      nGallery;
      nVideo;
      image;
      select;
      noSelect;
      options;
      wrapper;
      afterPayPrice;
      additionalText;
      shopBarToggles;
      quantitySelector;
      constructor() {
        super(),
          (this.currentVariant = window.theme.product.currentVariant),
          (this.form = this.querySelector("form")),
          (this.swatch = this.querySelector("#variantPicker")),
          (this.save_additional = this.querySelector(
            ".discount-additional-text"
          )),
          (this.input = this.form.querySelector('input[name="id"]')),
          (this.prices = this.querySelectorAll(".product-price")),
          (this.priceDiscount = this.querySelectorAll(
            ".product-price-discount"
          )),
          (this.specialDiscount = this.querySelectorAll(
            ".special-discount-item"
          )),
          (this.imageBar = document.querySelector(".shop-bar_image")),
          (this.shopBarToggleContainer = document.querySelector(".shop-bar-toggle-container")),
          (this.productFormContainer = document.querySelector(".product__info-container")),
          (this.shopBarClose = document.querySelector(".shop-bar-close")),
          (this.stars = this.querySelector("[data-oke-star-rating]")),
          (this.button = this.querySelector(".product-form__submit")),
          (this.SignButton = this.querySelector(".signup-btn")),
          (this.affirmText = this.querySelector(".affirm-as-low-as")),
          (this.gallery = document.querySelector(
            "product-form .product-gallery"
          )),
          (this.gallery2 = document.querySelector(
            ".product-gallery-grid .product-gallery"
          )),
          (this.nGallery = document.querySelector(".product-gallery-grid")),
          (this.nVideo = document.querySelector(
            ".product-gallery-grid .product-gallery_item-video"
          )),
          (this.wrapper = document.querySelector(".product__info-wrapper")),
          (this.shopBarToggleMobile = document.querySelector("#shop-bar-toggle-mobile")),
          (this.additionalText = document.querySelector(
            "#product-form_additional-text"
          )),
          (this.afterPayPrice = document.querySelector(".afterpay-price")),
          (this.productLabel = document.querySelector(
            "#best-seller-label-pdp"
          )),
          (this.submitting = !1),
          (this.shopBarToggles = this.querySelectorAll(".shop-bar-toggle")),
          (this.quantitySelector = this.querySelector(".quantity")),
          "Gift Card" === window.theme.product.type &&
            ((this.image = document.querySelector(
              "product-form .product-gallery img"
            )),
            (this.select = this.swatch.querySelector(
              ".blanket-options_select"
            )),
            (this.noSelect = !0),
            this.select.addEventListener(
              "click",
              this.handleSelect.bind(this)
            )),
          this.swatch &&
            ((this.option0 = this.swatch.querySelector(
              ".product_option0-value"
            )),
            (this.option1 = this.swatch.querySelector(
              ".product_option1-value"
            )),
            (this.option2 = this.swatch.querySelector(
              ".product_option2-value"
            )),
            (this.option3 = this.swatch.querySelector(
              ".product_option3-value"
            )),
            this.swatch.addEventListener(
              "change",
              this.onVariantChange.bind(this)
            ),
            (this.firstLoad = !0),
            this.onVariantChange(),
            this.showOnlyAvailableColors()),
          this.form.addEventListener("submit", this.handleForm.bind(this)),
          this.classList.contains("shop-bar-disabled") ||
            window.addEventListener("scroll", this.handleScroll.bind(this)),
          this.stars &&
            this.stars.addEventListener("click", () => {
              const t = document.querySelector(
                "[data-oke-carousel], [data-oke-widget]"
              );
              t &&
                window.scrollTo({ top: t.offsetTop - 70, behavior: "smooth" });
            }),
          this.handleLables(),
          this.handleSkuPrime(),
          this.shopBarClose.addEventListener("click", () => {
            this.productFormContainer.classList.remove("active");
          }),
          this.shopBarToggleMobile.addEventListener("click", () => {
            this.productFormContainer.classList.toggle("active");
          });
      }
      showOnlyAvailableColors() {
        const t = this.swatch.querySelectorAll('input[name="Color"]');
        window.theme.hideUnavailableWeights &&
          t &&
          t.forEach((t) => {
            window.theme.product.variants.find(
              (e) => e.options[0] === t.value && e.available
            ) || t.nextElementSibling.setAttribute("hidden", "");
          });
      }
      handleSkuPrime() {
        let t = window.theme.product.skuPrime,
          e = !1;
        if (void 0 !== t)
          for (let i = 0; i < t.length; i++)
            t[i] == window.theme.product.currentVariant.sku && (e = !0);
        const i = document.querySelector("#product-form_additional-text");
        e
          ? (i && i.classList.add("hidden"), (e = !1))
          : i && i.classList.remove("hidden");
      }
      handleLables() {
        if ("Gift Card" !== window.theme.product.type && this.productLabel) {
          if (this.currentVariant.available) {
            this.productLabel.innerHTML = this.currentVariant.variant_label || "";
          } else {
            // If tag exists, keep showing it even if not available
            if (this.currentVariant.variant_label) {
              this.productLabel.innerHTML = this.currentVariant.variant_label;
            } 
          }
          this.productLabel.style.background =
            this.currentVariant.variant_label_color || "";
        }
      }
      handleScroll() {
        const toggleContainer = this.shopBarToggleContainer;
        const t = this.parentElement,
          i = this.formVisible();
        
        if (i) {
          // Form is visible - hide toggle container
          if (t.style.minHeight !== "") {
            t.style.minHeight = "";
          }
          toggleContainer.style.display = "none";
          this.classList.remove("shop-bar");
        } else {
          // Form is not visible - show toggle container
          if (t.style.minHeight === "") {
            t.style.minHeight = t.offsetHeight + "px";
          }
          toggleContainer.style.display = "flex";
          this.classList.add("shop-bar");
        }
      }
      formVisible() {
        let t = this.wrapper.offsetTop - 70,
          e = this.wrapper.offsetLeft,
          i = this.wrapper.offsetWidth,
          r = this.wrapper.offsetHeight;
        return (
          t < window.pageYOffset + window.innerHeight &&
          e < window.pageXOffset + window.innerWidth &&
          t + r > window.pageYOffset &&
          e + i > window.pageXOffset
        );
      }
      handleForm(t) {
        if ((t.preventDefault(), this.submitting)) return;
        this.submitting = !0;
        const e = this.querySelector('[type="submit"]');
        e && (e.setAttribute("disabled", "true"), e.classList.add("loading"));

        // Check if button has link-to-checkout class
        const shouldRedirectToCheckout = e && e.classList.contains("link-to-checkout");

        if (window.theme.product.template == "biscuit-bundle") {
          const formData = window.theme.utils.serializeForm(this.form);
          const i = JSON.stringify([formData]);
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => t.json())
            .then((t) => {
              if (shouldRedirectToCheckout) {
                window.location.href = "/checkout";
              } else {
                window.theme.cart.render(t, !0); // Pass the response to the render function
              }
            })
            .catch((e) => {
              // Removed console.error
              t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              if (!shouldRedirectToCheckout) {
                const t = document.querySelector(".close");
                t && t.click();
              }
            });
        } else {
          const i = JSON.stringify({
            ...JSON.parse(window.theme.utils.serializeForm(this.form)),
          });
          fetch("/cart/add", { ...window.theme.fetchConfig(), body: i })
            .then((t) => t.json())
            .then((t) => {
              if (shouldRedirectToCheckout) {
                window.location.href = "/checkout";
              } else {
                window.theme.cart.render(!0);
              }
            })
            .catch((e) => {
              // Removed console.error
              t.target.submit();
            })
            .finally(() => {
              (this.submitting = !1),
                e &&
                  (e.classList.remove("loading"),
                  e.removeAttribute("disabled"));
              if (!shouldRedirectToCheckout) {
                const t = document.querySelector(".close");
                t && t.click();
              }
            });
        }
      }
      onVariantChange() {
        this.updateOptions(),
          this.updateMasterId(),
          this.updateMedia(),
          this.checkAvailability(),
          this.updateURL(),
          this.updateVariantInput(),
          (window.theme.product.currentVariant = this.currentVariant),
          this.changeElements(),
          this.handleLables(),
          this.handleSkuPrime(),
          this.handleLpColors(),
          this.updateAfterpay(),
          this.currentVariant.options.forEach((t, e) => {
            this.setAttribute(`data-option${e + 1}`, t);
          }),
          40597836693690 === this.currentVariant.id
            ? this.button.classList.add("hidden")
            : this.button.classList.remove("hidden"),
          "product" in this.currentVariant &&
            (window.theme.product.title = this.currentVariant.product),
          this.updateAffirm(),
          this.noSelect &&
            !this.select.hasAttribute("open") &&
            (this.select.setAttribute("selected", ""), (this.noSelect = !1));
      }
      updateAfterpay() {
        if (this.afterPayPrice) {
          const t = this.currentVariant.price;
          this.afterPayPrice.dataset.mobilePrice = t;
        }
      }
      updateAffirm() {
        if (
          this.affirmText &&
          "undefined" != typeof affirm &&
          affirm.jsReady()
        ) {
          const t = this.currentVariant.price.replace("$", "") + "00";
          this.affirmText.setAttribute("data-amount", t), affirm.ui.refresh();
        }
      }
      updateOptions() {
        // Build options array based on product.options order, not DOM order
        // This ensures this.options[i] matches variant.options[i]
        if (window.theme.product.options) {
          this.options = window.theme.product.options.map((optionName) => {
            const input = this.swatch.querySelector(`input[name="${optionName}"]:checked`);
            return input ? input.value : false;
          });
        } else {
          // Fallback to old method if options not available
          const t = Array.from(this.swatch.querySelectorAll("fieldset"));
          this.options = t.map((t) => {
            const e = Array.from(t.querySelectorAll("input")).find(
              (t) => t.checked
            );
            return !!e && e.value;
          });
        }
        
        window.theme.product.landing && this.options.shift();
      }
      updateMasterId() {
        const t = window.theme.hideUnavailableWeights,
          e = this.currentVariant.sizes.join(",");
        const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                           (window.theme.product && window.theme.product.handle === 'body-pillow');
        if (
          ((this.currentVariant = window.theme.product.variants.find(
            (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1)
          )),
          this.currentVariant ||
            (this.currentVariant = window.theme.product.variants.find(
              (t) => t.options[0] === this.options[0]
            )),
          t &&
            "Color" === window.theme.product.options[0] &&
            "Weight (lbs)" === window.theme.product.options[1])
        ) {
          this.setAttribute("data-hide-weights", "true");
          const t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          
          if (0 === t.length) return;
          
          for (var i = 0; i < t.length; i++) {
            var r = t[i];
            const e = r.value;
            var o = r.nextElementSibling;
            
            const availableVariant = window.theme.product.variants.find(
              function (variant) {
                return (
                  variant.options[1] === e &&
                  variant.options[0] === this.currentVariant?.options?.[0] &&
                  variant.available
                );
              }.bind(this)
            );
            
            availableVariant
              ? o.removeAttribute("hidden")
              : o.setAttribute("hidden", "");
          }
          const e = this.querySelector(
            'input[name="' +
              window.theme.product.options[1] +
              '"] + label:not([hidden])'
          );
          !this.currentVariant?.available && e && e.click();
        } else if (this.currentVariant.sizes.join(",") !== e) {
          this.querySelector(
            'input[value="' + this.currentVariant.options[1] + '"]'
          ).click(),
            (this.options = this.currentVariant.options);
          let t = this.querySelectorAll(
            'input[name="' + window.theme.product.options[1] + '"]'
          );
          if (0 === t.length) return;
          for (let e = 0; e < t.length; e++) {
            const i = t[e],
              r = i.nextElementSibling;
            this.currentVariant.sizes.includes(i.value)
              ? r.removeAttribute("hidden")
              : r.setAttribute("hidden", "");
          }
        }
      }
      updateMedia() {
        if ("Sleeper" !== window.theme.product.title) {
          if ("Gift Card" === window.theme.product.type) {
            const t = window.theme.product.images[this.currentVariant.color][1];
            (this.image.src = t.src),
              (this.image.alt = t.alt),
              this.updateGallery(
                window.theme.product.images[this.currentVariant.color]
              );
          } else {

            const isOceanNapper = window.location.pathname.includes('ocean-napper') || 
                                (window.theme.product && window.theme.product.handle === 'ocean-napper');
            const isHuggerSelected = isOceanNapper && this.currentVariant.options && 
                                    (this.currentVariant.options.includes('Queen 20') || this.currentVariant.options.includes('King 25'));

            const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                                (window.theme.product && window.theme.product.handle === 'body-pillow');
            const isMediumSelected = isBodyPillow && this.currentVariant.options && 
                                    (this.currentVariant.options.includes('54"') || this.currentVariant.options.includes('Medium'));
            let t;
            if (isMediumSelected) {
              const mediumColorKey = 'medium-' + this.currentVariant.color;
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][mediumColorKey]
                : window.theme.product.images[mediumColorKey];
                console.log('t1',t, mediumColorKey);
              if (!t) {
                t = window.theme.product.landing
                  ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                  : window.theme.product.images[this.currentVariant.color];
              }
            } else {
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                : window.theme.product.images[this.currentVariant.color];
            }
             if (isHuggerSelected) {
              const huggerColorKey = 'hugger-' + this.currentVariant.color;
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][huggerColorKey]
                : window.theme.product.images[huggerColorKey];
              console.log('t1',t, huggerColorKey);
              if (!t) {
                t = window.theme.product.landing
                  ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                  : window.theme.product.images[this.currentVariant.color];
              }
            } else {
              t = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][this.currentVariant.color]
                : window.theme.product.images[this.currentVariant.color];
            }
            t &&
              (this.gallery.update(t, window.theme.product.video),
              this.gallery2 &&
                this.gallery2.update(t, window.theme.product.video),
              this.updateGallery(t));
          }
          (this.imageBar.src = this.currentVariant.image),
            window.theme.product.videoObserverInit &&
              window.theme.product.videoObserverInit();
        }
      }
      updateGallery(t) {
        if ("true" === this.nGallery.dataset.slider || 0 === t.length) return;
        let e = "";
        t.forEach(function (t, i) {
          e += `\n      <div class="product-gallery_item product-gallery_item-image pointer">  \n        <div class="media media--square">\n          <img src="${t.src}" alt="${t.alt}" width="800" height="1000" class="cover-image" loading="lazy" onclick="window.theme.product.modal(${i})">\n        </div>\n      </div>`;
        }),
          window.theme.product.video
            ? (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${window.theme.product.video.image}" onclick="window.theme.product.modal(${t.length})">\n          <source src="${window.theme.product.video.src}" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`)
            : window.theme.product.videos &&
              window.theme.product.videos[this.currentVariant.product] &&
              (e += `\n    <div class="product-gallery_item product-gallery_item-video pointer">  \n      <div class="media media--square">\n        <video playsinline autoplay loop muted class="cover-image" poster="${
                window.theme.product.videos[this.currentVariant.product].image
              }" onclick="window.theme.product.modal(${
                t.length
              })">\n          <source src="${
                window.theme.product.videos[this.currentVariant.product].src
              }" type="video/mp4">\n          Your browser does not support the video tag.\n        </video> \n      </div>\n    </div>`),
          (this.nGallery.innerHTML = e);
      }
      updateURL() {
        if (window.theme.product.landing) return;
        if (this.firstLoad) return void (this.firstLoad = !1);
        const t = new URLSearchParams(window.location.search);
        t.set("variant", this.currentVariant.id);
        const e = window.location.pathname + "?" + t.toString();
        history.pushState(null, "", e);
      }
      updateVariantInput() {
        (this.input.value = this.currentVariant.id),
          this.input.dispatchEvent(new Event("change", { bubbles: !0 }));
      }
      checkAvailability() {
        this.currentVariant.available
          ? this.removeAttribute("soldout")
          : this.setAttribute("soldout", "");
      }

      changeElements() {
        const isBodyPillow = window.location.pathname.includes('body-pillow') || 
                           (window.theme.product && window.theme.product.handle === 'body-pillow');
        if (window.theme.product.currentVariant.is_preoder === "true") {
          document.querySelector('#product-form_preorder-text').style.display = 'block';
          document.querySelector('#product-form_preorder-text').innerHTML = window.theme.product.currentVariant.preorder_text;
          this.button.innerHTML = "PRE-ORDER";
        } else {
          this.button.innerHTML = "ADD TO CART";
          document.querySelector('#product-form_preorder-text').style.display = 'none';
        }
        const t = document.querySelectorAll(
            ".product-price-compare.compare-price"
          ),
          e = document.querySelectorAll(".tag--save"),
          i = document.querySelectorAll(".compare-price-cart.product-price");
        let r = this.currentVariant.price,
          o = parseFloat(r.replace("$", ""));
        var n = 0;

        if (
          ((o = o.toFixed(0)),
          t.forEach((t) => {
            let r = !1;
            if (window.theme.product.sku_discounts == true) {
              if (window.theme.product.currentVariant.discount != "") {
                const isFixedDiscount = window.theme.product.currentVariant.is_fixed_discount;
                let discountedPrice;
                
                if (isFixedDiscount) {
                  // Fixed dollar amount discount
                  const discountAmount = parseFloat(window.theme.product.currentVariant.discount) * 100;
                  discountedPrice = o - discountAmount;
                  n = discountedPrice / o; // for compatibility
                } else {
                  // Percentage discount
                  n = 1 - window.theme.product.currentVariant.discount / 100;
                  discountedPrice = o * n;
                }
                
                e.forEach((e) => {
                  e.dataset.textDiscount = isFixedDiscount 
                    ? "$" + window.theme.product.currentVariant.discount + " off"
                    : window.theme.product.currentVariant.discount + "% off";
                  e.style.display = "flex";
                });
                i.forEach((i) => {
                  i.style.display = "";
                }),
                  (document.querySelector(
                    ".discount-additional-text-wrapper"
                  ).style.display = "block");
                this.save_additional.innerHTML = isFixedDiscount
                  ? "Save $" + window.theme.product.currentVariant.discount + " "
                  : "Save " + window.theme.product.currentVariant.discount + "% ";
                t.classList.add("red"),
                  (t.innerHTML = `$${Math.round(discountedPrice)}`),
                  (this.button.dataset.mobilePrice = `$${Math.round(discountedPrice)}`),
                  (this.button.setAttribute('data-mobile-price' , `$${Math.round(discountedPrice)}`));
              } else {
                e.forEach((e) => {
                  e.style.display = "none";
                });
                t.innerHTML = this.currentVariant.price;
                t.classList.remove("red");
                i.forEach((i) => {
                  i.style.display = "none";
                });
                const discountWrapper = document.querySelector(".discount-additional-text-wrapper");
                if (discountWrapper) {
                  discountWrapper.style.display = "none";
                }
                this.button.dataset.mobilePrice = this.currentVariant.price;
              }
            } else {
              this.specialDiscount.forEach((o) => {
                if (o.innerHTML == window.theme.product.currentVariant.id)
                  return (
                    (n = 1 - o.dataset.specialDiscount / 100),
                    t.classList.add("red"),
                    (document.querySelector(
                      ".discount-additional-text-wrapper"
                    ).style.display = "block"),
                    (this.save_additional.style.display = "inline-block"),
                    (i[0].style.display = "block"),
                    e.forEach((t) => {
                      (t.dataset.textDiscount =
                        o.dataset.specialDiscount + "% off"),
                        (t.style.display = "flex"),
                        (this.save_additional.innerHTML =
                          "Save " + o.dataset.specialDiscount + "% ");
                    }),
                    void (r = !0)
                  );
              }),
                r ||
                  (() => {
                    const isFixed = t.dataset.isFixed === "true";
                    let discountedPrice;
                    
                    if (isFixed) {
                      const discountAmount = parseFloat(t.dataset.discount) * 100;
                      discountedPrice = o - discountAmount;
                      n = discountedPrice / o;
                    } else {
                      n = 1 - t.dataset.discount / 100;
                      discountedPrice = o * n;
                    }
                    
                    t.classList.add("red");
                    document.querySelector(".discount-additional-text-wrapper").style.display = "block";
                    this.save_additional.style.display = "inline-block";
                    i[0].style.display = "block";
                    this.save_additional.innerHTML = isFixed
                      ? "Save $" + t.dataset.discount + " "
                      : "Save " + t.dataset.discount + "% ";
                    e.forEach((e) => {
                      e.dataset.textDiscount = isFixed
                        ? "$" + t.dataset.discount + " off"
                        : t.dataset.discount + "% off";
                      e.style.display = "flex";
                    });
                    t.innerHTML = `$${Math.round(discountedPrice)}`;
                    this.button.dataset.mobilePrice = `$${Math.round(discountedPrice)}`;
                  })();
            }
          }),
          this.prices.forEach((t) => {
            t.innerHTML = this.currentVariant.price;
          }),
          this.priceDiscount.forEach((t) => {
            let e = parseFloat(
                this.currentVariant.price.replace(/[^0-9.-]+/g, "")
              ),
              i = Math.ceil(1.11 * e);
            t.innerHTML = "$" + i.toFixed(0);
          }),
          (this.SignButton.dataset.unitPrice = this.currentVariant.price),
          (this.button.dataset.bundlePrice = this.currentVariant.price),
          (this.button.dataset.unitPrice = this.currentVariant.price),
          this.option1 &&
            (this.option1.innerHTML = this.currentVariant.options[0]),
          window.theme.product.options[1] &&
            window.theme.product.options[1].includes("Weight"))
        )
          this.option3 &&
            (this.option3.innerHTML = this.currentVariant.options[2]),
            this.option2 &&
              (this.option2.innerHTML =
                this.currentVariant.options[1]
                  .replace("Queen ", "")
                  .replace("King ", "") +
                " lbs " +
                window.theme.getDimension(this.currentVariant.options[1]));
        else if (
          "Size" === window.theme.product.options[0] &&
          "Sleeper" === window.theme.product.title
        )
          this.option1 &&
            (this.option1.innerHTML =
              this.currentVariant.options[0] +
              window.theme.getDimension(this.currentVariant.options[0]));
        else if (
          window.theme.product.options[1] &&
          "Size" === window.theme.product.options[1] &&
          "Gift Card" !== window.theme.product.type
        ) {
          let t = this.currentVariant.options[1];
          "Small" === t && "Pupper Pod" === window.theme.product.title
            ? (t = "Small1")
            : "Medium" === t &&
              "Pupper Pod" === window.theme.product.title &&
              (t = "Medium1"),
            this.option2 &&
              (this.option2.innerHTML =
                this.currentVariant.options[1] + window.theme.getDimension(t));
        } else
          this.option2 &&
            (this.option2.innerHTML = this.currentVariant.options[1]);
        if (
          (this.option0 &&
            ((this.option0.innerHTML = this.currentVariant.product),
            (this.option0.href =
              window.theme.product.urls[this.currentVariant.product] || "")),
          window.theme.extraColors && this.productLabel)
        ) {
          const t = window.theme.extraColors.includes(
              this.currentVariant.options[0]
            ),
            e = this.option1
              .closest(".form__label")
              .classList.contains("form__label--2");
          t && !e
            ? (this.swatch
                .querySelector(".form__label--2")
                .appendChild(this.option1),
              this.swatch
                .querySelector(".form__label--2")
                .appendChild(this.productLabel))
            : !t &&
              e &&
              (this.swatch
                .querySelector(".form__label--1")
                .appendChild(this.option1),
              this.swatch
                .querySelector(".form__label--1")
                .appendChild(this.productLabel));
        }
      }
      handleSelect(t) {
        "INPUT" !== t.target.tagName &&
          (this.select.hasAttribute("open")
            ? this.select.removeAttribute("open")
            : this.select.setAttribute("open", ""));
      }
      handleLpColors() {
        const t = this.querySelector('[name="Type"]:checked');
        "weight-lp" === this.dataset.type &&
          t &&
          (this.querySelectorAll(".swatch-color label:not([hidden])").forEach(
            (e) => {
              e.dataset.product === t.value
                ? e.classList.remove("d-none")
                : e.classList.add("d-none");
            }
          ),
          this.querySelector('[name="Color"]:checked + label.d-none') &&
            this.querySelector(
              '[name="Color"] + label:not(.d-none):not([hidden])'
            ).click());
      }
    }
    customElements.define("product-form", t);
    
    (function () {
        var t = document.querySelector("#product-zoom-modal");
        if (t) {
          const r = t.querySelector("img"),
            o = t.querySelector("video"),
            n = t.querySelector(".slider-next"),
            s = t.querySelector(".slider-prev");
          function e(t) {
            let e,
              i = parseInt(r.dataset.index);
            e = window.theme.product.landing
              ? window.theme.product.images[
                  window.theme.product.currentVariant.product
                ][window.theme.product.currentVariant.color]
              : "Sleeper" === window.theme.product.title
              ? window.theme.product.images.sleeper
              : window.theme.product.images[
                  window.theme.product.currentVariant.color
                ];
            const n = e.length - 1;
            if (o && (("next" === t && i === n) || ("prev" === t && 0 === i))) {
              o.removeAttribute("hidden");
              const t = o.play();
              return (
                void 0 !== t &&
                  t.catch(function (t) {
                    /* removed console.log */
                  }),
                void (r.dataset.index = e.length.toString())
              );
            }
            "next" === t
              ? i >= n
                ? (i = 0)
                : i++
              : "prev" === t && (0 === i ? (i = n) : i--),
              (r.src = ""),
              o && !o.paused && (o.pause(), o.setAttribute("hidden", "")),
              (r.src = e[i].src),
              (r.dataset.index = i.toString());
          }
          (window.theme.product.modal = function (e) {
            let i;
            if (
              ((i = window.theme.product.landing
                ? window.theme.product.images[this.currentVariant.product][
                    this.currentVariant.color
                  ]
                : "Sleeper" === window.theme.product.title
                ? window.theme.product.images.sleeper
                : window.theme.product.images[this.currentVariant.color]),
              i)
            ) {
              if (e === i.length) {
                o.removeAttribute("hidden");
                const t = o.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    /* removed console.log */
                  });
              } else {
                (r.src = ""),
                  o && !o.paused && (o.pause(), o.setAttribute("hidden", ""));
                const t = i[e];
                r.src = t.src.replace("_800x", "");
              }
              (r.dataset.index = e.toString()),
                document.body.classList.add("body_fade"),
                document.body.classList.add("header_fade"),
                t.setAttribute("open", "");
            }
          }),
            n.addEventListener("click", function () {
              e("next");
            }),
            s.addEventListener("click", function () {
              e("prev");
            });
        }
        const i = new IntersectionObserver(
          (t) => {
            t.forEach((t) => {
              const e = t.target;
              if (t.isIntersecting) {
                const t = e.play();
                void 0 !== t &&
                  t.catch(function (t) {
                    /* removed console.log */
                  });
              } else e.pause();
            });
          },
          { threshold: 0.2 }
        );
        document.querySelectorAll(".product-gallery video").forEach((t) => {
          i.observe(t);
        });
      })();
  })();
  const t = document.querySelectorAll("[data-tab-target]"),
    e = document.querySelectorAll("[data-tab-content]");
  t.forEach((i) => {
    i.addEventListener("click", () => {
      const r = document.querySelector(i.dataset.tabTarget);
      e.forEach((t) => {
        t.classList.remove("active");
      }),
        t.forEach((t) => {
          t.classList.remove("active");
        }),
        i.classList.add("active"),
        r.classList.add("active");
    });
  });
  class i extends HTMLElement {
    constructor() {
      super(),
        (this.originalHTML = this.innerHTML),
        (this.originalTextContent = this.textContent);
    }
    static get observedAttributes() {
      return ["limit", "open"];
    }
    get less() {
      return this.getAttribute("less");
    }
    get more() {
      return this.getAttribute("more");
    }
    get limit() {
      return this.hasAttribute("limit")
        ? Number(this.getAttribute("limit"))
        : 10;
    }
    get isOpen() {
      return this.hasAttribute("open");
    }
    attributeChangedCallback(t, e, i) {
      this.render();
    }
    render() {
      this.textContent.length > this.limit &&
        (this.isOpen
          ? ((this.innerHTML = this.originalHTML),
            (this.querySelector("p:last-child").innerHTML = `\n          ${
              this.querySelector("p:last-child").innerHTML
            }\n          <button type="button">${
              this.less
            }</button>\n        `))
          : (this.innerHTML = `\n          <p>\n            ${this.originalTextContent
              .trim()
              .slice(
                0,
                this.limit
              )}&hellip;\n            <button type="button">${
              this.more
            }</button>\n          </p>\n        `),
        this.querySelector("button")?.addEventListener(
          "click",
          this.toggle.bind(this)
        ));
    }
    toggle(t) {
      this.toggleAttribute("open");
    }
  }
  customElements.define("read-more", i);
})();
